module.exports = __webpack_public_path__ + "img/activity.4344532c.png";